module.exports = __webpack_public_path__ + "static/sec1-b8dcf035bf26c84c50049b0d3496bfc7.png";